var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-instance-page" },
    [
      _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
        _c("div", { staticClass: "nk-block-between align-items-start" }, [
          _c(
            "div",
            { staticClass: "nk-block-head-content admin-instance-list__intro" },
            [
              _c("div", { staticClass: "admin-instance-list__title-row" }, [
                _c("h3", { staticClass: "nk-block-title page-title mb-0" }, [
                  _vm._v(_vm._s(_vm.trans("subscription.subscription"))),
                ]),
              ]),
              _vm._v(" "),
              !_vm.subscriptions.total
                ? _c("div", { staticClass: "nk-block-des text-soft" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.trans("subscription.module_info_description")
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "nk-fmg-actions flex-shrink-0" }, [
            _c(
              "ul",
              {
                staticClass: "nk-block-tools g-2 flex-wrap justify-content-end",
              },
              [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.showFilterPanel = !_vm.showFilterPanel
                        },
                      },
                    },
                    [
                      _c("admin-icon", { attrs: { name: "sliders" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.trans("general.filter")))]),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showFilterPanel
          ? _c("div", { staticClass: "card admin-instance-form-card mb-2" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "admin-instance-card-head" }, [
                  _c("h4", { staticClass: "admin-instance-card-head__title" }, [
                    _vm._v(_vm._s(_vm.trans("general.filter"))),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "admin-instance-card-head__hint" }, [
                    _vm._v(_vm._s(_vm.trans("subscription.subscription"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("subscription.status"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSubscriptionForm.status,
                              expression: "filterSubscriptionForm.status",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "status" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterSubscriptionForm,
                                "status",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.trans("general.select_one"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v(_vm._s(_vm.trans("subscription.failed"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v(_vm._s(_vm.trans("subscription.complete"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("date-range-picker", {
                          attrs: {
                            "start-date": _vm.filterSubscriptionForm.start_date,
                            "end-date": _vm.filterSubscriptionForm.end_date,
                            label: _vm.trans("general.date_between"),
                          },
                          on: {
                            "update:startDate": function ($event) {
                              return _vm.$set(
                                _vm.filterSubscriptionForm,
                                "start_date",
                                $event
                              )
                            },
                            "update:start-date": function ($event) {
                              return _vm.$set(
                                _vm.filterSubscriptionForm,
                                "start_date",
                                $event
                              )
                            },
                            "update:endDate": function ($event) {
                              return _vm.$set(
                                _vm.filterSubscriptionForm,
                                "end_date",
                                $event
                              )
                            },
                            "update:end-date": function ($event) {
                              return _vm.$set(
                                _vm.filterSubscriptionForm,
                                "end_date",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("general.sort_by"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSubscriptionForm.sort_by,
                              expression: "filterSubscriptionForm.sort_by",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "order" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterSubscriptionForm,
                                "sort_by",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "created_at" } }, [
                            _vm._v(
                              _vm._s(_vm.trans("subscription.created_at"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "status" } }, [
                            _vm._v(_vm._s(_vm.trans("subscription.status"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("general.order"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSubscriptionForm.order,
                              expression: "filterSubscriptionForm.order",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "order" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterSubscriptionForm,
                                "order",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "asc" } }, [
                            _vm._v(_vm._s(_vm.trans("general.ascending"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "desc" } }, [
                            _vm._v(_vm._s(_vm.trans("general.descending"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.hasPermission("list-subscriber") && _vm.subscriptions.total
        ? _c("div", { staticClass: "admin-list-table-card mt-2" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table admin-data-table admin-data-table--config-list mb-0",
                },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      [
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.number"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.email"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.domain"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.amount"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.method"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.trans("plan.plan")))]),
                        _vm._v(" "),
                        _c(
                          "sortable-th",
                          {
                            attrs: {
                              field: "status",
                              "sort-by": _vm.filterSubscriptionForm.sort_by,
                              order: _vm.filterSubscriptionForm.order,
                            },
                            on: { sort: _vm.sortList },
                          },
                          [_vm._v(_vm._s(_vm.trans("subscription.status")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "sortable-th",
                          {
                            attrs: {
                              field: "created_at",
                              "sort-by": _vm.filterSubscriptionForm.sort_by,
                              order: _vm.filterSubscriptionForm.order,
                            },
                            on: { sort: _vm.sortList },
                          },
                          [_vm._v(_vm._s(_vm.trans("subscription.created_at")))]
                        ),
                        _vm._v(" "),
                        _c("th", { staticClass: "admin-table-actions-cell" }, [
                          _vm._v(_vm._s(_vm.trans("general.actions"))),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.subscriptions.data, function (subscription) {
                      return _c("tr", { key: subscription.id }, [
                        _c("td", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.getNumber(subscription)),
                            },
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-0" }, [
                            _c("small", [_vm._v(_vm._s(subscription.uuid))]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", {
                          domProps: {
                            textContent: _vm._s(subscription.instance.email),
                          },
                        }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "code",
                            { staticClass: "admin-instance-meta__code" },
                            [_vm._v(_vm._s(subscription.instance.domain))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.formatCurrency(
                                subscription.amount,
                                subscription.currency
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              subscription.source === "paypal"
                                ? "Paypal"
                                : "Credit Card"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", {
                          domProps: {
                            textContent: _vm._s(subscription.plan.name),
                          },
                        }),
                        _vm._v(" "),
                        _c("td", [
                          subscription.status
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "admin-status-badge admin-status-badge--success",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.trans("subscription.complete"))
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "admin-status-badge admin-status-badge--danger",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.trans("subscription.failed"))
                                  ),
                                ]
                              ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("moment")(subscription.created_at))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "admin-table-actions-cell" },
                          [
                            _c(
                              "table-row-action-dropdown",
                              [
                                subscription.status
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          href: `/subscription/${subscription.uuid}/print?token=${_vm.authToken}`,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: { name: "printer" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.trans("subscription.print")
                                            ) +
                                            "\n                                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                subscription.status
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          href: `/subscription/${subscription.uuid}/pdf?token=${_vm.authToken}`,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: { name: "file" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.trans("subscription.pdf")
                                            ) +
                                            "\n                                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !subscription.status
                                  ? _c(
                                      "b-dropdown-item-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.fetchDetail(subscription)
                                          },
                                        },
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: { name: "eye" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.trans("subscription.view")
                                            ) +
                                            "\n                                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasPermission("delete-subscription") &&
                                !subscription.status
                                  ? _c(
                                      "b-dropdown-item-button",
                                      {
                                        directives: [
                                          {
                                            name: "confirm",
                                            rawName: "v-confirm",
                                            value: {
                                              ok: _vm.confirmDelete(
                                                subscription
                                              ),
                                            },
                                            expression:
                                              "{ok: confirmDelete(subscription)}",
                                          },
                                        ],
                                        staticClass:
                                          "admin-row-actions__danger",
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: { name: "trash" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.trans(
                                                "subscription.delete_subscription"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "admin-table-pagination-wrap" },
              [
                _c("pagination-record", {
                  attrs: {
                    "page-length": _vm.filterSubscriptionForm.page_length,
                    records: _vm.subscriptions,
                  },
                  on: {
                    "update:pageLength": function ($event) {
                      return _vm.$set(
                        _vm.filterSubscriptionForm,
                        "page_length",
                        $event
                      )
                    },
                    "update:page-length": function ($event) {
                      return _vm.$set(
                        _vm.filterSubscriptionForm,
                        "page_length",
                        $event
                      )
                    },
                    updateRecords: _vm.getSubscriptions,
                  },
                  nativeOn: {
                    change: function ($event) {
                      return _vm.getSubscriptions.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade subscription-detail admin-modal-pro",
          attrs: {
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "subscriptionDetail",
            "aria-hidden": "true",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c(
              "div",
              { staticClass: "modal-content admin-modal-pro__content" },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "subscriptionDetail" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.trans("subscription.subscription_detail")) +
                          " "
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "admin-status-badge admin-status-badge--danger",
                        },
                        [_vm._v(_vm._s(_vm.trans("subscription.failed")))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-hidden": "true",
                      },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _vm.subscription
                  ? _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 col-sm-6" }, [
                          _c("table", { staticClass: "table no-border" }, [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("subscription.type"))),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.subscription.type === "extend"
                                      ? "Validity Extend"
                                      : "Upgrade"
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("subscription.date"))),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("momentDateTime")(
                                      _vm.subscription.created_at
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("instance.email"))),
                              ]),
                              _vm.subscription.instance
                                ? _c("th", { staticClass: "font-medium" }, [
                                    _vm._v(
                                      _vm._s(_vm.subscription.instance.email)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("instance.domain"))),
                              ]),
                              _vm.subscription.instance
                                ? _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.subscription.instance.domain)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("plan.plan"))),
                              ]),
                              _vm.subscription.plan
                                ? _c("th", { staticClass: "font-medium" }, [
                                    _vm._v(_vm._s(_vm.subscription.plan.name)),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.trans("subscription.validity"))
                                ),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(_vm.subscription.validity)
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.trans("subscription.amount"))
                                ),
                              ]),
                              _vm.subscription.currency
                                ? _c("th", { staticClass: "font-medium" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCurrency(
                                          _vm.subscription.amount,
                                          _vm.subscription.currency
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.trans("subscription.fail_reason"))
                                ),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(
                                  _vm._s(_vm.subscription.gateway_status || "-")
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-6" }, [
                          _c("table", { staticClass: "table no-border" }, [
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.trans("user.address_line_1"))
                                ),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(_vm._s(_vm.subscription.address_line_1)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.trans("user.address_line_2"))
                                ),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(_vm._s(_vm.subscription.address_line_2)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("user.city"))),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(_vm._s(_vm.subscription.city)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("user.state"))),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(_vm._s(_vm.subscription.state)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("user.zipcode"))),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(_vm._s(_vm.subscription.zipcode)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("user.country"))),
                              ]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.countries[_vm.subscription.country]
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("IP")]),
                              _c("th", { staticClass: "font-medium" }, [
                                _vm._v(_vm._s(_vm.subscription.ip)),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(_vm._s(_vm.trans("general.close")))]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.subscriptions.total
        ? _c(
            "div",
            {
              staticClass: "admin-list-table-card admin-empty-state mt-3",
              attrs: { role: "status" },
            },
            [
              _c("div", { staticClass: "admin-empty-state__inner" }, [
                _c(
                  "div",
                  {
                    staticClass: "admin-empty-state__icon-wrap",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_c("admin-icon", { attrs: { name: "receipt" } })],
                  1
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "admin-empty-state__title" }, [
                  _vm._v(_vm._s(_vm.trans("subscription.empty_list_title"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "admin-empty-state__text" }, [
                  _vm._v(_vm._s(_vm.trans("subscription.empty_list_hint"))),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }